export default __webpack_public_path__ + "static/media/ReportIcon-ENT-MS.eb0c3421.jpg";